import { BlastEvent, SimulationConfig } from '../../../types';
import { getRadiusAtAngle } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const FireworkAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  for (let i = 0; i < 12; i++) {
    const angle = (i / 12) * Math.PI * 2;
    const dist = e.maxRadius + progress * 150;
    const r = getRadiusAtAngle(angle, e, dist);
    const cx = e.pos.x + Math.cos(angle) * r;
    const cy = e.pos.y + Math.sin(angle) * r;
    ctx.beginPath(); ctx.arc(cx, cy, 5 * (1-progress), 0, Math.PI * 2); ctx.fill();
  }
};

registerBlastAnimation('FIREWORK', FireworkAnimation);
